'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _a11y = require('../../core/a11y');

var _a11y2 = _interopRequireDefault(_a11y);

var _relay = require('../../core/relay42');

var _relay2 = _interopRequireDefault(_relay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbUserPrefsController.$inject = ['DyslexieService', 'ContrastService', 'Relay42Service'];


var _module = _angular2.default.module('cb.core.site-header.cbUserPrefsController', [_a11y2.default.name, _relay2.default.name]);

_module.controller('cbUserPrefsController', cbUserPrefsController);

exports.default = _module;


function cbUserPrefsController(DyslexieService, ContrastService, Relay42Service) {
    var vm = this;

    vm.zoomIn = zoomIn;
    vm.zoomOut = zoomOut;
    vm.setContrast = setContrast;
    vm.resetContrast = resetContrast;
    vm.setDyslexie = setDyslexie;
    vm.resetDyslexie = resetDyslexie;
    vm.showCookieSettings = showCookieSettings;

    ContrastService.toggleContrast();
    DyslexieService.toggleDyslexiefont();

    function zoomIn() {
        // todo
    }

    function zoomOut() {
        // todo
    }

    function setContrast() {
        ContrastService.enable();
    }

    function resetContrast() {
        ContrastService.disable();
    }

    function setDyslexie() {
        DyslexieService.enable();
    }

    function resetDyslexie() {
        DyslexieService.disable();
    }

    function showCookieSettings() {
        Relay42Service.showCookieSettings();
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/site-header/cb-user-prefs.controller.js
// module id = 907
// module chunks = 0